import axios from 'axios'
import { ambienteValido } from './regras'

export async function carregarEnvParceiro (ambienteStorage, envBuild) {
  const ambiente = ambienteValido(ambienteStorage) ? ambienteStorage : envBuild.VUE_APP_AMBIENTE
  let nome = ambiente === 'default' ? (envBuild.VUE_APP_NOME || ambiente) : ambiente
  try {
    const { data } = await axios.get(envBuild.VUE_APP_ROOT_API + 'Multiplo/GetPortalByAmbiente/' + ambiente, { timeout: 5000 })
    if (typeof data === 'string' && data.trim()) { nome = data.trim() }
  } catch {}
  return { ...envBuild, VUE_APP_AMBIENTE: ambiente, VUE_APP_NOME: nome }
}
